var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationFarAway = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.827 18.0601H25.1735C17.7213 18.0601 11.6802 24.1012 11.6802 31.5534V116.887C11.6802 124.339 17.7213 130.38 25.1735 130.38H174.827C182.279 130.38 188.32 124.339 188.32 116.887V31.5534C188.32 24.1012 182.279 18.0601 174.827 18.0601Z",
    fill: "#EEF9E8",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6802 111.66H188.32",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6802 92.9399H188.32",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6802 74.2202H188.32",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6802 55.5H188.32",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6802 36.7803H188.32",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.88 18.0601V130.38",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.44 18.0601V130.38",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100 18.0601V130.38",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5601 18.0601V130.38",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1201 18.0601V130.38",
    stroke: "#D7F9C2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.286 185.353L49.0798 139.287C43.5865 135.573 44.1198 127.32 50.0465 124.347L82.7398 107.953C85.5732 106.533 88.9532 106.773 91.5532 108.573L153.46 151.347C158.34 154.72 158.473 161.887 153.713 165.433L127.32 185.12C124.366 187.327 120.34 187.42 117.28 185.353H117.286Z",
    fill: "#E2E2E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3668 42.2998C92.3668 47.0665 83.7334 59.6532 83.7334 59.6532C83.7334 59.6532 75.1001 47.0665 75.1001 42.2998C75.1001 37.5332 78.9668 33.6665 83.7334 33.6665C88.5001 33.6665 92.3668 37.5332 92.3668 42.2998Z",
    fill: "#D60505"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.727 45.9799C85.9693 45.9799 87.787 44.1621 87.787 41.9199C87.787 39.6776 85.9693 37.8599 83.727 37.8599C81.4847 37.8599 79.667 39.6776 79.667 41.9199C79.667 44.1621 81.4847 45.9799 83.727 45.9799Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5732 43.0599C76.5732 38.9199 79.9332 35.5599 84.0732 35.5599C86.4932 35.5599 88.6465 36.7066 90.0199 38.4866C88.7265 36.2399 86.2999 34.7266 83.5132 34.7266C79.3732 34.7266 76.0132 38.0866 76.0132 42.2266C76.0132 43.9466 76.5932 45.5332 77.5665 46.7999C76.9332 45.6999 76.5665 44.4199 76.5665 43.0599H76.5732Z",
    fill: "#EB4943"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6932 56.3534C82.8665 58.3267 83.7265 59.6534 83.7265 59.6534C83.7265 59.6534 92.3599 47.0667 92.3599 42.3001C92.3599 42.0467 92.3465 41.8001 92.3265 41.5601C91.9865 42.8867 91.5065 44.1734 90.9132 45.4067C89.2799 48.8067 86.8599 50.9867 84.2865 53.7467C83.4599 54.6334 82.5932 55.5134 81.6865 56.3534H81.6932Z",
    fill: "#B70606"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3134 43.96L85.8267 44.4467C85.6734 44.6 85.4267 44.6 85.28 44.4467L83.7867 42.9533L82.2934 44.4467C82.14 44.6 81.8934 44.6 81.7467 44.4467L81.26 43.96C81.1067 43.8067 81.1067 43.56 81.26 43.4133L82.7534 41.92L81.26 40.4267C81.1067 40.2733 81.1067 40.0333 81.26 39.88L81.7467 39.3933C81.9 39.24 82.14 39.24 82.2934 39.3933L83.7867 40.8867L85.28 39.3933C85.4334 39.24 85.68 39.24 85.8267 39.3933L86.3134 39.88C86.4667 40.0333 86.4667 40.2733 86.3134 40.4267L84.82 41.92L86.3134 43.4133C86.4667 43.5667 86.4667 43.8067 86.3134 43.96Z",
    fill: "#D60505"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.114 136.853C164.46 139.713 162.774 142.233 160.367 143.92L131.954 163.853C126.754 167.166 120.107 167.16 114.914 163.833L45.8202 119.566C42.1135 117.193 39.9135 113.06 40.0135 108.666L40.0669 106.36L81.4202 87.3864C85.7735 85.393 90.8402 85.7397 94.8735 88.3197L163.074 131.886C164.734 132.946 165.547 134.933 165.114 136.853Z",
    fill: "#AFAFAF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.467 129.073C163.093 130.006 166.273 134.26 164.7 135.28L126.32 160.206C123.907 161.866 120.733 161.913 118.267 160.326L42.2067 111.26C39.1667 109.3 39.4134 104.773 42.6534 103.16L79.6667 84.6663C83.0734 82.9663 87.12 83.1463 90.36 85.1463L161.473 129.08L161.467 129.073Z",
    fill: "#D3D3D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.633 129.153C159.073 129.986 159.133 132.046 157.733 132.953L123.68 155.066C121.54 156.54 118.72 156.58 116.533 155.173L49.0535 111.64C46.3535 109.9 46.5735 105.886 49.4468 104.453L82.2868 88.0463C85.3068 86.533 88.9001 86.6996 91.7735 88.473L157.633 129.16V129.153Z",
    fill: "#07A587"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.92 148.846L128.693 143.406C130.087 142.546 129.793 140.44 128.22 139.986C121.207 137.96 113.667 138.88 107.347 142.533L117.953 148.866C118.56 149.226 119.313 149.22 119.913 148.853L119.92 148.846Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.427 140.107L151.56 129.633C152.12 129.307 152.12 128.493 151.56 128.173L140.46 121.767C140.02 121.513 139.453 121.7 139.26 122.173L132.207 139.047C132.013 139.513 132.267 140.04 132.747 140.18C132.747 140.18 132.753 140.18 132.76 140.18C132.98 140.247 133.22 140.213 133.42 140.1L133.427 140.107Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.04 119.046L129.347 138.34C124.8 136.893 120.713 136.673 116.04 137.48L123.467 119.18L134.267 117.446L137.04 119.046Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.627 138.22L115.32 131.58L94.3667 129.1L90.8467 133.013L105.447 141.44C107.693 140.066 110.08 138.973 112.62 138.22H112.627Z",
    fill: "#27DEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.087 112.727L132.64 116.507L123.987 117.9L126.087 112.727Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6132 113.646C83.5266 113.12 84.9999 113.12 85.9132 113.646C86.8266 114.173 86.8266 115.026 85.9132 115.553C84.9999 116.08 83.5266 116.08 82.6132 115.553C81.6999 115.026 81.6999 114.173 82.6132 113.646Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.213 119.313L87.8067 115.473C87.4667 116.253 86.88 116.426 85.52 116.726L94.56 127.066L116.12 129.62L120.213 119.313Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.82 109.533L102.44 115.306L87.7066 113.56C87.4266 113.24 86.9999 112.973 86.4399 112.746L88.4599 107.6L104.813 109.54L104.82 109.533Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.573 111.273L121.04 117.513L104.9 115.6L107.44 109.36L123.573 111.273Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.547 109.52L93.8132 94.0864L89.1865 105.8L120.547 109.52Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3069 116.54L92.1803 127.827L88.6669 131.74L69.5869 120.72L81.3603 116.093C81.6669 116.28 81.9803 116.433 82.3136 116.533L82.3069 116.54Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5 104.32L91.4467 94.3198C91.7467 93.5664 91.4667 92.7064 90.7867 92.2731L88.0267 90.5064C87.5133 90.1798 86.86 90.1531 86.32 90.4331L68.2733 99.9998C66.8133 100.773 67.2133 102.96 68.8467 103.173L85.7067 105.38C86.4733 105.48 87.2133 105.046 87.5 104.32Z",
    fill: "#8FFFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1667 103.52L53.4534 108.573C52.4667 109.146 52.4667 110.566 53.4534 111.14L64.9134 117.753C65.3067 117.98 65.78 118.013 66.2 117.846L77.3667 113.446C77.7534 113.293 78.0867 113 78.2134 112.606C78.34 112.213 78.68 111.793 79.3334 111.42C79.88 111.106 80.5267 110.933 81.24 110.846C81.78 110.786 82.2334 110.426 82.4334 109.92L83.36 107.56C83.7134 106.653 83.12 105.66 82.1534 105.546L63.0934 103.333C62.7734 103.293 62.4534 103.36 62.18 103.52H62.1667Z",
    fill: "#8FFFD1"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7202 105.426V101.853L96.2402 102.506V106.073L90.7202 105.426Z",
    fill: "#27DEBF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2402 102.506L97.3736 99.3262V103.266L96.2402 106.073V102.506Z",
    fill: "#27DEBF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3735 99.3262L91.9802 98.6729L90.7202 101.853L96.2402 102.506L97.3735 99.3262Z",
    fill: "#27DEBF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.7202 105.426V101.853L96.2402 102.506V106.073L90.7202 105.426Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M96.2402 102.506L97.3736 99.3262V103.266L96.2402 106.073V102.506Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M97.3735 99.3262L91.9802 98.6729L90.7202 101.853L96.2402 102.506L97.3735 99.3262Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3403 113.053V111.453L99.8537 112.099V113.706L94.3403 113.053Z",
    fill: "#27DEBF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8535 112.1L100.84 109.346V111.313L99.8535 113.706V112.1Z",
    fill: "#27DEBF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.84 109.346L95.4403 108.693L94.3403 111.453L99.8537 112.1L100.84 109.346Z",
    fill: "#27DEBF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M94.3403 113.053V111.453L99.8537 112.099V113.706L94.3403 113.053Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M99.8535 112.1L100.84 109.346V111.313L99.8535 113.706V112.1Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M100.84 109.346L95.4403 108.693L94.3403 111.453L99.8537 112.1L100.84 109.346Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.96 134.107V130.533L110.48 131.187V134.76L104.96 134.107Z",
    fill: "#27DEBF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M110.48 131.186L111.614 128.006V131.946L110.48 134.76V131.186Z",
    fill: "#27DEBF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.614 128.007L106.22 127.36L104.96 130.533L110.48 131.187L111.614 128.007Z",
    fill: "#27DEBF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M104.96 134.107V130.533L110.48 131.187V134.76L104.96 134.107Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M110.48 131.186L111.614 128.006V131.946L110.48 134.76V131.186Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M111.614 128.007L106.22 127.36L104.96 130.533L110.48 131.187L111.614 128.007Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104.867 107.033V105.713L107.661 106.046V107.36L104.867 107.033Z",
    fill: "#27DEBF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.661 106.047L108.234 104.44V105.94L107.661 107.36V106.047Z",
    fill: "#27DEBF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M108.234 104.44L105.501 104.106L104.867 105.713L107.661 106.046L108.234 104.44Z",
    fill: "#27DEBF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M104.867 107.033V105.713L107.661 106.046V107.36L104.867 107.033Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M107.661 106.047L108.234 104.44V105.94L107.661 107.36V106.047Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M108.234 104.44L105.501 104.106L104.867 105.713L107.661 106.046L108.234 104.44Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5205 100.826V98.9131L88.5805 99.3931V101.306L84.5205 100.826Z",
    fill: "#27DEBF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5806 99.3932L89.4206 97.0532V99.2399L88.5806 101.307V99.3932Z",
    fill: "#27DEBF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4205 97.0532L85.4405 96.5732L84.5205 98.9132L88.5805 99.3932L89.4205 97.0532Z",
    fill: "#27DEBF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M84.5205 100.826V98.9131L88.5805 99.3931V101.306L84.5205 100.826Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M88.5806 99.3932L89.4206 97.0532V99.2399L88.5806 101.307V99.3932Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M89.4205 97.0532L85.4405 96.5732L84.5205 98.9132L88.5805 99.3932L89.4205 97.0532Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M105.354 114.479V112.779L108.974 113.206V114.913L105.354 114.479Z",
    fill: "#27DEBF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M108.974 113.206L109.72 111.12V113.066L108.974 114.913V113.206Z",
    fill: "#27DEBF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M109.72 111.12L106.18 110.693L105.354 112.78L108.974 113.206L109.72 111.12Z",
    fill: "#27DEBF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M105.354 114.479V112.779L108.974 113.206V114.913L105.354 114.479Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M108.974 113.206L109.72 111.12V113.066L108.974 114.913V113.206Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M109.72 111.12L106.18 110.693L105.354 112.78L108.974 113.206L109.72 111.12Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9268 112.446V110.693L92.6534 111.133V112.886L88.9268 112.446Z",
    fill: "#27DEBF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6533 111.133L93.42 108.986V110.986L92.6533 112.886V111.133Z",
    fill: "#27DEBF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4201 108.986L89.7734 108.546L88.9268 110.693L92.6534 111.133L93.4201 108.986Z",
    fill: "#27DEBF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M88.9268 112.446V110.693L92.6534 111.133V112.886L88.9268 112.446Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M92.6533 111.133L93.42 108.986V110.986L92.6533 112.886V111.133Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M93.4201 108.986L89.7734 108.546L88.9268 110.693L92.6534 111.133L93.4201 108.986Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M110.041 115.02V113.313L113.661 113.746V115.453L110.041 115.02Z",
    fill: "#27DEBF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M113.661 113.746L114.407 111.66V113.606L113.661 115.453V113.746Z",
    fill: "#27DEBF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M114.407 111.66L110.861 111.233L110.041 113.313L113.661 113.746L114.407 111.66Z",
    fill: "#27DEBF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.041 115.02V113.313L113.661 113.746V115.453L110.041 115.02Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M113.661 113.746L114.407 111.66V113.606L113.661 115.453V113.746Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M114.407 111.66L110.861 111.233L110.041 113.313L113.661 113.746L114.407 111.66Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M114.72 115.56V113.853L118.347 114.286V115.993L114.72 115.56Z",
    fill: "#27DEBF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M118.347 114.286L119.087 112.2V114.146L118.347 115.993V114.286Z",
    fill: "#27DEBF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M119.087 112.2L115.547 111.773L114.72 113.853L118.347 114.286L119.087 112.2Z",
    fill: "#27DEBF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M114.72 115.56V113.853L118.347 114.286V115.993L114.72 115.56Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M118.347 114.286L119.087 112.2V114.146L118.347 115.993V114.286Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M119.087 112.2L115.547 111.773L114.72 113.853L118.347 114.286L119.087 112.2Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3872 109.866V108.16L75.0139 108.593V110.3L71.3872 109.866Z",
    fill: "#27DEBF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0137 108.593L75.7537 106.506V108.453L75.0137 110.3V108.593Z",
    fill: "#27DEBF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7539 106.506L72.2139 106.08L71.3872 108.16L75.0139 108.593L75.7539 106.506Z",
    fill: "#27DEBF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.3872 109.866V108.16L75.0139 108.593V110.3L71.3872 109.866Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M75.0137 108.593L75.7537 106.506V108.453L75.0137 110.3V108.593Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M75.7539 106.506L72.2139 106.08L71.3872 108.16L75.0139 108.593L75.7539 106.506Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0737 110.406V108.7L79.6937 109.133V110.84L76.0737 110.406Z",
    fill: "#27DEBF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6938 109.133L80.4405 107.046V108.993L79.6938 110.84V109.133Z",
    fill: "#27DEBF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4404 107.047L76.9004 106.613L76.0737 108.7L79.6937 109.133L80.4404 107.047Z",
    fill: "#27DEBF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M76.0737 110.406V108.7L79.6937 109.133V110.84L76.0737 110.406Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M79.6938 109.133L80.4405 107.046V108.993L79.6938 110.84V109.133Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.4404 107.047L76.9004 106.613L76.0737 108.7L79.6937 109.133L80.4404 107.047Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7603 110.946V109.24L84.3803 109.673V111.38L80.7603 110.946Z",
    fill: "#27DEBF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3804 109.673L85.127 107.586V109.533L84.3804 111.379V109.673Z",
    fill: "#27DEBF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1269 107.586L81.5803 107.153L80.7603 109.24L84.3803 109.673L85.1269 107.586Z",
    fill: "#27DEBF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M80.7603 110.946V109.24L84.3803 109.673V111.38L80.7603 110.946Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M84.3804 109.673L85.127 107.586V109.533L84.3804 111.379V109.673Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M85.1269 107.586L81.5803 107.153L80.7603 109.24L84.3803 109.673L85.1269 107.586Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M127.514 104.393V103.379L130.58 103.739V104.753L127.514 104.393Z",
    fill: "#27DEBF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M127.514 104.393V103.379L130.58 103.739V104.753L127.514 104.393Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M130.581 103.74L131.034 102.426V103.66L130.581 104.753V103.74Z",
    fill: "#27DEBF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M130.581 103.74L131.034 102.426V103.66L130.581 104.753V103.74Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M131.034 102.426L128.034 102.06L127.514 103.38L130.58 103.74L131.034 102.426Z",
    fill: "#27DEBF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M131.034 102.426L128.034 102.06L127.514 103.38L130.58 103.74L131.034 102.426Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M105.747 125.873V124.166L109.367 124.593V126.299L105.747 125.873Z",
    fill: "#27DEBF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M109.367 124.593L110.114 122.506V124.453L109.367 126.3V124.593Z",
    fill: "#27DEBF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M110.114 122.506L106.574 122.08L105.747 124.166L109.367 124.593L110.114 122.506Z",
    fill: "#27DEBF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M105.747 125.873V124.166L109.367 124.593V126.299L105.747 125.873Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M109.367 124.593L110.114 122.506V124.453L109.367 126.3V124.593Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M110.114 122.506L106.574 122.08L105.747 124.166L109.367 124.593L110.114 122.506Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M110.267 126.413V124.706L113.887 125.133V126.839L110.267 126.413Z",
    fill: "#27DEBF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M113.887 125.133L114.634 123.046V124.993L113.887 126.84V125.133Z",
    fill: "#27DEBF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M114.634 123.046L111.094 122.62L110.267 124.706L113.887 125.133L114.634 123.046Z",
    fill: "#27DEBF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.267 126.413V124.706L113.887 125.133V126.839L110.267 126.413Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M113.887 125.133L114.634 123.046V124.993L113.887 126.84V125.133Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M114.634 123.046L111.094 122.62L110.267 124.706L113.887 125.133L114.634 123.046Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3071 131.593V129.886L97.9271 130.313V132.02L94.3071 131.593Z",
    fill: "#27DEBF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9272 130.313L98.6739 128.227V130.173L97.9272 132.02V130.313Z",
    fill: "#27DEBF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6738 128.226L95.1338 127.8L94.3071 129.886L97.9271 130.313L98.6738 128.226Z",
    fill: "#27DEBF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M94.3071 131.593V129.886L97.9271 130.313V132.02L94.3071 131.593Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M97.9272 130.313L98.6739 128.227V130.173L97.9272 132.02V130.313Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M98.6738 128.226L95.1338 127.8L94.3071 129.886L97.9271 130.313L98.6738 128.226Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8271 132.127V130.42L102.447 130.853V132.56L98.8271 132.127Z",
    fill: "#27DEBF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M102.447 130.853L103.194 128.76V130.713L102.447 132.56V130.853Z",
    fill: "#27DEBF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M103.194 128.76L99.6538 128.333L98.8271 130.42L102.447 130.853L103.194 128.76Z",
    fill: "#27DEBF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M98.8271 132.127V130.42L102.447 130.853V132.56L98.8271 132.127Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M102.447 130.853L103.194 128.76V130.713L102.447 132.56V130.853Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M103.194 128.76L99.6538 128.333L98.8271 130.42L102.447 130.853L103.194 128.76Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M126.307 123.486V121.779L129.927 122.213V123.919L126.307 123.486Z",
    fill: "#27DEBF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M129.927 122.213L130.674 120.12V122.073L129.927 123.92V122.213Z",
    fill: "#27DEBF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M130.674 120.12L127.134 119.693L126.307 121.78L129.927 122.213L130.674 120.12Z",
    fill: "#27DEBF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M126.307 123.486V121.779L129.927 122.213V123.919L126.307 123.486Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M129.927 122.213L130.674 120.12V122.073L129.927 123.92V122.213Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M130.674 120.12L127.134 119.693L126.307 121.78L129.927 122.213L130.674 120.12Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M124.887 127.006V125.299L128.507 125.726V127.433L124.887 127.006Z",
    fill: "#27DEBF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M128.507 125.726L129.254 123.64V125.586L128.507 127.433V125.726Z",
    fill: "#27DEBF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M129.254 123.64L125.714 123.213L124.887 125.3L128.507 125.726L129.254 123.64Z",
    fill: "#27DEBF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M124.887 127.006V125.299L128.507 125.726V127.433L124.887 127.006Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M128.507 125.726L129.254 123.64V125.586L128.507 127.433V125.726Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M129.254 123.64L125.714 123.213L124.887 125.3L128.507 125.726L129.254 123.64Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M123.467 130.52V128.813L127.087 129.246V130.946L123.467 130.52Z",
    fill: "#27DEBF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M127.087 129.247L127.834 127.153V129.107L127.087 130.947V129.247Z",
    fill: "#27DEBF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M127.833 127.153L124.293 126.727L123.467 128.813L127.087 129.247L127.833 127.153Z",
    fill: "#27DEBF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M123.467 130.52V128.813L127.087 129.246V130.946L123.467 130.52Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M127.087 129.247L127.834 127.153V129.107L127.087 130.947V129.247Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M127.833 127.153L124.293 126.727L123.467 128.813L127.087 129.247L127.833 127.153Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M122.047 134.04V132.333L125.667 132.76V134.467L122.047 134.04Z",
    fill: "#27DEBF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M125.667 132.76L126.414 130.673V132.62L125.667 134.467V132.76Z",
    fill: "#27DEBF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M126.414 130.673L122.867 130.247L122.047 132.333L125.667 132.76L126.414 130.673Z",
    fill: "#27DEBF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M122.047 134.04V132.333L125.667 132.76V134.467L122.047 134.04Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M125.667 132.76L126.414 130.673V132.62L125.667 134.467V132.76Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M126.414 130.673L122.867 130.247L122.047 132.333L125.667 132.76L126.414 130.673Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M120.16 122.773V121.066L123.78 121.493V123.2L120.16 122.773Z",
    fill: "#27DEBF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M123.78 121.493L124.527 119.406V121.353L123.78 123.2V121.493Z",
    fill: "#27DEBF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M124.527 119.406L120.987 118.979L120.16 121.066L123.78 121.493L124.527 119.406Z",
    fill: "#27DEBF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M120.16 122.773V121.066L123.78 121.493V123.2L120.16 122.773Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M123.78 121.493L124.527 119.406V121.353L123.78 123.2V121.493Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M124.527 119.406L120.987 118.979L120.16 121.066L123.78 121.493L124.527 119.406Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M118.74 126.286V124.586L122.36 125.013V126.719L118.74 126.286Z",
    fill: "#27DEBF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M122.36 125.013L123.107 122.926V124.873L122.36 126.72V125.013Z",
    fill: "#27DEBF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M123.107 122.926L119.567 122.5L118.74 124.586L122.36 125.013L123.107 122.926Z",
    fill: "#27DEBF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M118.74 126.286V124.586L122.36 125.013V126.719L118.74 126.286Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M122.36 125.013L123.107 122.926V124.873L122.36 126.72V125.013Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M123.107 122.926L119.567 122.5L118.74 124.586L122.36 125.013L123.107 122.926Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M117.32 129.806V128.1L120.94 128.526V130.233L117.32 129.806Z",
    fill: "#27DEBF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M120.94 128.527L121.687 126.44V128.387L120.94 130.233V128.527Z",
    fill: "#27DEBF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M121.687 126.44L118.14 126.013L117.32 128.1L120.94 128.527L121.687 126.44Z",
    fill: "#27DEBF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M117.32 129.806V128.1L120.94 128.526V130.233L117.32 129.806Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M120.94 128.527L121.687 126.44V128.387L120.94 130.233V128.527Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M121.687 126.44L118.14 126.013L117.32 128.1L120.94 128.527L121.687 126.44Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M115.9 133.32V131.613L119.52 132.047V133.753L115.9 133.32Z",
    fill: "#27DEBF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M119.521 132.046L120.267 129.959V131.906L119.521 133.753V132.046Z",
    fill: "#27DEBF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M120.267 129.96L116.72 129.526L115.9 131.613L119.52 132.046L120.267 129.96Z",
    fill: "#27DEBF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M115.9 133.32V131.613L119.52 132.047V133.753L115.9 133.32Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M119.521 132.046L120.267 129.959V131.906L119.521 133.753V132.046Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M120.267 129.96L116.72 129.526L115.9 131.613L119.52 132.046L120.267 129.96Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M132.307 129.207V127.86L135.16 128.2V129.54L132.307 129.207Z",
    fill: "#27DEBF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M135.161 128.2L135.747 126.56V128.093L135.161 129.54V128.2Z",
    fill: "#27DEBF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M135.747 126.56L132.96 126.22L132.307 127.86L135.16 128.2L135.747 126.56Z",
    fill: "#27DEBF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M132.307 129.207V127.86L135.16 128.2V129.54L132.307 129.207Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M135.161 128.2L135.747 126.56V128.093L135.161 129.54V128.2Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M135.747 126.56L132.96 126.22L132.307 127.86L135.16 128.2L135.747 126.56Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M130.887 133.16V131.813L133.734 132.153V133.493L130.887 133.16Z",
    fill: "#27DEBF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M133.734 132.153L134.321 130.513V132.046L133.734 133.493V132.153Z",
    fill: "#27DEBF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M134.321 130.513L131.534 130.173L130.887 131.813L133.734 132.153L134.321 130.513Z",
    fill: "#27DEBF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M130.887 133.16V131.813L133.734 132.153V133.493L130.887 133.16Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M133.734 132.153L134.321 130.513V132.046L133.734 133.493V132.153Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M134.321 130.513L131.534 130.173L130.887 131.813L133.734 132.153L134.321 130.513Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M100.293 125.166V118.773L104.787 119.3V125.693L100.293 125.166Z",
    fill: "#27DEBF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M100.293 125.166V118.773L104.787 119.3V125.693L100.293 125.166Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M104.787 119.3L105.367 117.74V124.453L104.787 125.693V119.3Z",
    fill: "#27DEBF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M104.787 119.3L105.367 117.74V124.453L104.787 125.693V119.3Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M105.367 117.74L100.98 117.213L100.293 118.773L104.787 119.3L105.367 117.74Z",
    fill: "#27DEBF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M105.367 117.74L100.98 117.213L100.293 118.773L104.787 119.3L105.367 117.74Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6001 103.673V96.1064L80.1868 96.3998V103.96L77.6001 103.673Z",
    fill: "#27DEBF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M77.6001 103.673V96.1064L80.1868 96.3998V103.96L77.6001 103.673Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1865 96.3999L80.7665 94.8398V102.72L80.1865 103.96V96.3999Z",
    fill: "#27DEBF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M80.1865 96.3999L80.7665 94.8398V102.72L80.1865 103.96V96.3999Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7668 94.8399L78.2801 94.5532L77.6001 96.1066L80.1868 96.3999L80.7668 94.8399Z",
    fill: "#27DEBF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.7668 94.8399L78.2801 94.5532L77.6001 96.1066L80.1868 96.3999L80.7668 94.8399Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4736 103.407V96.7402L81.847 96.8869V103.554L80.4736 103.407Z",
    fill: "#27DEBF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M80.4736 103.407V96.7402L81.847 96.8869V103.554L80.4736 103.407Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8472 96.8869L82.0605 96.2002V103.147L81.8472 103.554V96.8869Z",
    fill: "#27DEBF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M81.8472 96.8869L82.0605 96.2002V103.147L81.8472 103.554V96.8869Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0603 96.2001L80.7803 96.0601L80.4736 96.7401L81.847 96.8867L82.0603 96.2001Z",
    fill: "#27DEBF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M82.0603 96.2001L80.7803 96.0601L80.4736 96.7401L81.847 96.8867L82.0603 96.2001Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9268 124.527V118.133L99.4201 118.66V125.053L94.9268 124.527Z",
    fill: "#27DEBF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M94.9268 124.527V118.133L99.4201 118.66V125.053L94.9268 124.527Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4199 118.66L99.9999 117.1V123.813L99.4199 125.053V118.66Z",
    fill: "#27DEBF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M99.4199 118.66L99.9999 117.1V123.813L99.4199 125.053V118.66Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M100 117.1L95.6134 116.573L94.9268 118.133L99.4201 118.66L100 117.1Z",
    fill: "#27DEBF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M100 117.1L95.6134 116.573L94.9268 118.133L99.4201 118.66L100 117.1Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1338 104.393V102.479L87.1938 102.959V104.873L83.1338 104.393Z",
    fill: "#27DEBF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1938 102.96L88.0272 100.62V102.8L87.1938 104.873V102.96Z",
    fill: "#27DEBF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0271 100.62L84.0538 100.14L83.1338 102.48L87.1938 102.96L88.0271 100.62Z",
    fill: "#27DEBF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M83.1338 104.393V102.479L87.1938 102.959V104.873L83.1338 104.393Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M87.1938 102.96L88.0272 100.62V102.8L87.1938 104.873V102.96Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M88.0271 100.62L84.0538 100.14L83.1338 102.48L87.1938 102.96L88.0271 100.62Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5935 118.113L76.6802 119.787L74.3535 118.453L77.4135 116.687L79.5935 118.113Z",
    fill: "#27DEBF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M79.5935 118.113L76.6802 119.787L74.3535 118.453L77.4135 116.687L79.5935 118.113Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3535 119.84V118.453L76.6802 119.786V121.18L74.3535 119.84Z",
    fill: "#27DEBF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M74.3535 119.84V118.453L76.6802 119.786V121.18L74.3535 119.84Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5935 118.113V119.5L76.6802 121.18V119.787L79.5935 118.113Z",
    fill: "#27DEBF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M79.5935 118.113V119.5L76.6802 121.18V119.787L79.5935 118.113Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8403 120.026L79.9336 121.706L77.6069 120.373L80.6603 118.606L82.8403 120.026Z",
    fill: "#27DEBF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M82.8403 120.026L79.9336 121.706L77.6069 120.373L80.6603 118.606L82.8403 120.026Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6069 121.753V120.373L79.9336 121.706V123.1L77.6069 121.753Z",
    fill: "#27DEBF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M77.6069 121.753V120.373L79.9336 121.706V123.1L77.6069 121.753Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8403 120.026V121.42L79.9336 123.1V121.706L82.8403 120.026Z",
    fill: "#27DEBF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M82.8403 120.026V121.42L79.9336 123.1V121.706L82.8403 120.026Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1604 121.926L83.2537 123.606L80.9204 122.273L83.9804 120.506L86.1604 121.926Z",
    fill: "#27DEBF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M86.1604 121.926L83.2537 123.606L80.9204 122.273L83.9804 120.506L86.1604 121.926Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9204 123.653V122.273L83.2537 123.606V125L80.9204 123.653Z",
    fill: "#27DEBF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M80.9204 123.653V122.273L83.2537 123.606V125L80.9204 123.653Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1606 121.926V123.32L83.2539 125V123.606L86.1606 121.926Z",
    fill: "#27DEBF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M86.1606 121.926V123.32L83.2539 125V123.606L86.1606 121.926Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M90.867 122.786L87.9603 124.466L85.627 123.126L88.687 121.366L90.867 122.786Z",
    fill: "#27DEBF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M90.867 122.786L87.9603 124.466L85.627 123.126L88.687 121.366L90.867 122.786Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M85.627 126.459V123.126L87.9603 124.466V127.799L85.627 126.459Z",
    fill: "#27DEBF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M85.627 126.459V123.126L87.9603 124.466V127.799L85.627 126.459Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8671 122.786V126.126L87.9604 127.799V124.466L90.8671 122.786Z",
    fill: "#27DEBF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M90.8671 122.786V126.126L87.9604 127.799V124.466L90.8671 122.786Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4803 114.953L70.327 116.133L67.9937 114.8L71.3003 113.533L73.4803 114.953Z",
    fill: "#27DEBF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M73.4803 114.953L70.327 116.133L67.9937 114.8L71.3003 113.533L73.4803 114.953Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9937 116.18V114.8L70.327 116.133V117.526L67.9937 116.18Z",
    fill: "#27DEBF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M67.9937 116.18V114.8L70.327 116.133V117.526L67.9937 116.18Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4805 114.953V116.346L70.3271 117.526V116.133L73.4805 114.953Z",
    fill: "#27DEBF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M73.4805 114.953V116.346L70.3271 117.526V116.133L73.4805 114.953Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5335 113.026L75.3802 114.206L73.0469 112.873L76.3535 111.606L78.5335 113.026Z",
    fill: "#27DEBF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M78.5335 113.026L75.3802 114.206L73.0469 112.873L76.3535 111.606L78.5335 113.026Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0469 114.253V112.873L75.3802 114.206V115.6L73.0469 114.253Z",
    fill: "#27DEBF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M73.0469 114.253V112.873L75.3802 114.206V115.6L73.0469 114.253Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5337 113.026V114.42L75.3804 115.6V114.206L78.5337 113.026Z",
    fill: "#27DEBF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M78.5337 113.026V114.42L75.3804 115.6V114.206L78.5337 113.026Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M97.667 106.106V104.086L103.56 104.78V106.8L97.667 106.106Z",
    fill: "#27DEBF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M97.667 106.106V104.086L103.56 104.78V106.8L97.667 106.106Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M103.561 104.78L104.807 101.3V103.72L103.561 106.8V104.78Z",
    fill: "#27DEBF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M103.561 104.78L104.807 101.3V103.72L103.561 106.8V104.78Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M104.807 101.3L99.0403 100.606L97.667 104.086L103.56 104.78L104.807 101.3Z",
    fill: "#27DEBF"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M104.807 101.3L99.0403 100.606L97.667 104.086L103.56 104.78L104.807 101.3Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4204 103.586V93.7529L103.04 94.2929V104.126L98.4204 103.586Z",
    fill: "#27DEBF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M98.4204 103.586V93.7529L103.04 94.2929V104.126L98.4204 103.586Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M103.041 94.2931L104.047 91.4731V101.633L103.041 104.126V94.2931Z",
    fill: "#27DEBF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M103.041 94.2931L104.047 91.4731V101.633L103.041 104.126V94.2931Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M104.047 91.4731L99.5404 90.9331L98.4204 93.7531L103.04 94.2931L104.047 91.4731Z",
    fill: "#27DEBF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M104.047 91.4731L99.5404 90.9331L98.4204 93.7531L103.04 94.2931L104.047 91.4731Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8604 93.1198V87.7598L102.38 88.0531V93.4131L99.8604 93.1198Z",
    fill: "#27DEBF"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M99.8604 93.1198V87.7598L102.38 88.0531V93.4131L99.8604 93.1198Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M102.38 88.0532L102.934 86.5132V92.0532L102.38 93.4132V88.0532Z",
    fill: "#27DEBF"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M102.38 88.0532L102.934 86.5132V92.0532L102.38 93.4132V88.0532Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 86.5131L100.467 86.2197L99.8604 87.7597L102.38 88.0531L102.934 86.5131Z",
    fill: "#27DEBF"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M102.934 86.5131L100.467 86.2197L99.8604 87.7597L102.38 88.0531L102.934 86.5131Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M126.561 120.253V104.753L131.174 105.3V120.793L126.561 120.253Z",
    fill: "#27DEBF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M126.561 120.253V104.753L131.174 105.3V120.793L126.561 120.253Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M131.174 105.3L131.847 103.32V119.146L131.174 120.793V105.3Z",
    fill: "#27DEBF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M131.174 105.3L131.847 103.32V119.146L131.174 120.793V105.3Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M131.847 103.32L127.341 102.78L126.561 104.753L131.174 105.3L131.847 103.32Z",
    fill: "#27DEBF"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M131.847 103.32L127.341 102.78L126.561 104.753L131.174 105.3L131.847 103.32Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M134.027 125.193V110.847L138.054 111.293V125.64L134.027 125.193Z",
    fill: "#27DEBF"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M134.027 125.193V110.847L138.054 111.293V125.64L134.027 125.193Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M138.054 111.293L138.96 108.867V123.713L138.054 125.64V111.293Z",
    fill: "#27DEBF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M138.054 111.293L138.96 108.867V123.713L138.054 125.64V111.293Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M138.96 108.867L135.094 108.42L134.027 110.847L138.054 111.293L138.96 108.867Z",
    fill: "#27DEBF"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M138.96 108.867L135.094 108.42L134.027 110.847L138.054 111.293L138.96 108.867Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M138.507 124.787V111.827L140.64 112.053V125.013L138.507 124.787Z",
    fill: "#27DEBF"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M138.507 124.787V111.827L140.64 112.053V125.013L138.507 124.787Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M140.64 112.053L140.967 110.993V124.373L140.64 125.013V112.053Z",
    fill: "#27DEBF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M140.64 112.053L140.967 110.993V124.373L140.64 125.013V112.053Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M140.967 110.993L138.974 110.767L138.507 111.827L140.64 112.053L140.967 110.993Z",
    fill: "#27DEBF"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M140.967 110.993L138.974 110.767L138.507 111.827L140.64 112.053L140.967 110.993Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3336 102.52L70.1936 102.866C70.3336 103.773 70.4736 104.686 70.6203 105.593C70.6803 105.986 70.8536 106.353 71.127 106.64C71.5603 107.1 72.067 107.486 72.6203 107.76C73.507 108.193 74.3536 108.713 75.3003 109.04C75.747 109.193 76.3803 109.433 76.1336 110.053C76.0536 110.266 75.8136 110.413 75.5936 110.353H68.4536C68.1603 110.353 67.7736 110.16 67.6136 109.913C67.447 109.666 67.3803 109.366 67.3136 109.073C67.1403 108.24 67.027 107.393 66.967 106.546H66.9536L66.3203 102.52H66.3336Z",
    fill: "#C1813E"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8999 110.373H75.7466C76.1866 110.373 76.4599 109.873 76.1932 109.52C75.7932 109 74.9599 108.759 74.3932 108.486C74.0932 108.339 73.7932 108.193 73.4666 108.113C73.1399 108.033 72.7932 108.026 72.4866 108.16C71.9532 108.386 71.6199 108.986 71.0532 109.106C70.6599 109.193 70.2532 109.019 69.9466 108.766C69.6332 108.513 69.3999 108.186 69.1266 107.893C68.8999 107.653 68.6466 107.433 68.3732 107.24C68.1999 107.12 68.0199 107.006 67.8199 106.96C67.6199 106.906 67.3932 106.919 67.2199 107.039C66.6666 107.406 67.3532 109.553 67.4399 109.993C67.4866 110.22 67.6799 110.38 67.9066 110.38L67.8999 110.373Z",
    fill: "#2D2D2D"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9068 103L59.0002 105.493C59.0202 106.026 59.2535 106.533 59.6402 106.893C59.9935 107.226 60.3935 107.52 60.8268 107.733C61.7068 108.18 62.5535 108.706 63.4935 109.04C63.9335 109.2 64.5668 109.446 64.3135 110.06C64.2268 110.266 63.9868 110.413 63.7668 110.353L56.6268 110.266C56.3335 110.266 55.9535 110.066 55.7935 109.82C55.6335 109.566 55.5668 109.273 55.5068 108.98C55.3935 108.42 55.3735 107.793 55.3602 107.186H55.3268L55.1802 102.413L58.9068 102.993V103Z",
    fill: "#C1813E"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M56.08 110.293L64.0067 110.387C64.36 110.387 64.62 110.04 64.4867 109.713C64.46 109.647 64.4267 109.587 64.3867 109.533C63.9934 109.013 63.16 108.767 62.6 108.48C62.3 108.333 62 108.18 61.68 108.1C61.36 108.02 61.0067 108.007 60.7 108.133C60.1667 108.353 59.82 108.947 59.2534 109.067C58.86 109.147 58.4534 108.967 58.1467 108.713C57.84 108.46 57.6067 108.127 57.3334 107.833C57.1067 107.587 56.86 107.367 56.5934 107.173C56.4267 107.053 56.2467 106.94 56.04 106.887C55.8334 106.833 55.6134 106.847 55.4334 106.96C54.8734 107.32 55.54 109.48 55.62 109.913C55.66 110.14 55.86 110.3 56.0867 110.307L56.08 110.293Z",
    fill: "#2D2D2D"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5934 72.3864L71.2868 103.246H64.8401L62.3334 81.7331L60.2134 103.326H53.7734L55.6601 79.2198C55.7868 77.8531 55.9334 76.3331 56.0601 74.9664C56.1001 74.5331 56.1401 74.0998 56.2134 73.6731C56.3134 73.0731 56.4801 72.4798 56.7134 71.9131L67.6001 72.3864",
    fill: "#D7D8D6"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 58.6596L62.8733 55.6529C61.76 54.3596 61.6733 52.4863 62.6267 51.0529C62.8867 50.6663 63.2267 50.3396 63.6067 50.0596C64.1667 49.6463 64.8067 49.3329 65.4933 49.2196C66.18 49.1063 66.8267 48.9796 67.3333 49.4463C67.96 50.0263 68.4133 50.7729 68.7467 51.5529C69.08 52.3396 69.3067 53.1596 69.5333 53.9863C69.5667 54.1063 69.5933 54.2396 69.5333 54.3463C69.44 54.5129 69.2 54.4996 69.0067 54.4663C69.02 54.9796 69.0333 55.4863 69.0467 55.9996C69.06 56.6596 69.1667 57.6996 68.24 57.7663H67.06L65.74 59.9529L61.5 58.6529",
    fill: "#C1813E"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8799 52.8531C67.8799 52.9731 67.9665 53.0665 68.0865 53.0732C68.1999 53.0732 68.2999 52.9865 68.3065 52.8665C68.3065 52.7465 68.2199 52.6532 68.0999 52.6465C67.9866 52.6465 67.8865 52.7331 67.8799 52.8531Z",
    fill: "#0E1010"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7866 54.9065C68.8466 54.8931 68.7533 54.9065 68.7333 54.9065C68.6733 54.9065 68.6133 54.9065 68.5599 54.9065C68.3599 54.8798 68.1999 54.7731 68.0799 54.6065C67.9933 54.4798 67.7999 54.6198 67.8866 54.7465C68.1133 55.0531 68.4933 55.2131 68.8666 55.1265C69.0133 55.0931 68.9266 54.8731 68.7799 54.9065H68.7866Z",
    fill: "#8B5624"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5532 57.313L66.6266 58.4063L67.2466 57.3663L65.5532 57.313Z",
    fill: "#B25E23"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4334 55.5664C61.3734 55.4464 61.3201 55.3331 61.2734 55.2264C60.8334 54.2131 60.7401 53.0464 61.0734 51.9864C61.6467 50.1664 63.4534 48.8131 65.3534 48.7664C65.8001 48.7531 66.2467 48.8064 66.6801 48.7064C67.1734 48.5931 67.7267 48.2931 68.1134 48.6664C68.2534 48.7997 68.3267 48.9997 68.3267 49.1931C68.3267 49.9731 67.7734 50.5864 67.1001 50.8864C66.7001 51.0664 66.2667 51.1531 65.8267 51.2064C65.5134 51.2464 65.2801 51.5197 65.2934 51.8331L65.3267 53.1997C65.3267 53.3664 65.1534 53.4797 65.0067 53.3997C64.6667 53.2131 64.2601 53.1331 63.9401 53.3064C63.6934 53.4397 63.5334 53.6997 63.4601 53.9664C63.2667 54.6597 63.6267 55.4731 64.2801 55.7864C64.3067 56.3731 64.2734 57.2597 63.5334 57.3197C62.6067 57.3864 61.8467 56.3797 61.4267 55.5597L61.4334 55.5664Z",
    fill: "#0E1010"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1401 48.4463C63.3601 50.0463 62.2467 51.5197 60.6467 51.7397C59.0467 51.9597 57.5734 50.8463 57.3534 49.2463C57.1334 47.6463 58.2467 46.173 59.8467 45.953C61.4467 45.733 62.9201 46.8463 63.1401 48.4463Z",
    fill: "#0E1010"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M69.66 64.4595L71.4267 68.4661C71.52 68.6795 71.7533 68.7928 71.98 68.7261L79.7933 66.5261C80.06 66.3795 80.22 66.1528 80.4667 65.9728C81.0267 65.5795 81.7 65.3995 82.3667 65.2328C82.5333 65.1928 82.7 65.1461 82.8667 65.1128C83.0133 65.0795 83.1867 65.0861 83.32 65.0195C83.3467 65.0061 83.3733 64.9928 83.4067 64.9928C83.5267 64.9928 83.5 65.1995 83.4733 65.2661C83.4267 65.3861 83.3267 65.4795 83.2267 65.5528C82.9667 65.7328 82.68 65.8728 82.44 66.0795C82.2733 66.2261 82.0133 66.4528 82.2533 66.6395C82.52 66.8395 83.0067 66.7061 83.3 66.6395C83.4933 66.5995 83.6933 66.5395 83.8933 66.5328C84.0933 66.5261 84.3067 66.5728 84.4467 66.7195C84.6067 66.8861 84.62 67.2195 84.6067 67.4395C84.58 67.7528 84.2533 67.7461 84.1 67.9595C84.0467 68.0395 84.0267 68.1395 83.98 68.2195C83.86 68.4128 83.58 68.4461 83.42 68.6128C83.2933 68.7395 83.24 68.9528 83.0733 69.0195C82.6667 69.1861 82.0867 69.0795 81.66 69.0595L71.32 72.6661C70.5733 72.9261 69.7533 72.5995 69.3867 71.9061L65.8267 65.1661L69.68 64.4595",
    fill: "#C1813E"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7335 59.1999C66.9602 59.3799 68.0135 60.1532 68.5535 61.2732C68.5535 61.2732 70.6735 64.7799 70.2135 66.0465C70.0402 66.5265 69.6202 66.9332 69.1135 67.0132L67.8135 74.2265L56.6802 73.9665L58.4402 62.2865C58.2068 60.1532 60.0535 58.3665 62.1802 58.6799L65.7335 59.2065",
    fill: "url(#paint0_linear_31451_20360)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9932 77.2329C57.1732 77.4996 57.3132 77.7929 57.4532 78.0796C57.6266 78.4396 57.6732 78.6929 57.6999 79.0929C57.7532 79.8796 57.7732 80.6662 57.7599 81.4596C57.7599 81.5396 57.7466 81.6329 57.6799 81.6729C57.6199 81.7062 57.5466 81.6729 57.4932 81.6396C57.1399 81.3929 57.2066 80.8329 56.9332 80.4996C56.8999 80.4596 56.8599 80.4262 56.8132 80.4262C56.7532 80.4262 56.7199 80.4929 56.6999 80.5529C56.5466 81.0396 56.7799 81.6862 56.9266 82.1529C57.0466 82.5396 57.3999 83.6396 56.8732 83.9129C56.5466 84.0796 55.9599 83.7329 55.6932 83.5929C53.5532 82.4929 53.9732 79.3462 54.3466 77.4196",
    fill: "#C1813E"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7801 64.3662L62.1601 65.2462L58.4467 70.4395L56.9134 78.4195L54.2334 78.5462L54.6934 70.4529C54.7134 70.1129 54.7867 69.7729 54.9067 69.4529L56.7734 64.3662",
    fill: "#C1813E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5933 66.4196L61.5533 67.5797L63.3466 62.7597C64.0999 60.7397 62.5533 58.6063 60.3999 58.693C59.1533 58.7463 58.0666 59.553 57.6666 60.733L55.5933 66.4196Z",
    fill: "#F4B01A"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5266 58.6865C60.6866 58.6865 60.8466 58.6999 60.9999 58.7265C62.4733 58.9599 63.5399 60.2532 63.5399 61.7065C63.5399 62.0532 63.4799 62.4065 63.3466 62.7599L61.5533 67.5799L55.5933 66.4199L57.6666 60.7332C58.0666 59.5532 59.1533 58.7399 60.3999 58.6932C60.4399 58.6932 60.4866 58.6932 60.5266 58.6932",
    fill: "url(#paint1_linear_31451_20360)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3133 56.0528C64.4348 56.0528 64.5333 55.9543 64.5333 55.8328C64.5333 55.7113 64.4348 55.6128 64.3133 55.6128C64.1918 55.6128 64.0933 55.7113 64.0933 55.8328C64.0933 55.9543 64.1918 56.0528 64.3133 56.0528Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0666 68.9396L81.5466 67.0063C81.3866 66.8063 81.3799 66.4929 81.5266 66.2396L84.1066 61.7263C84.3333 61.3263 84.8199 61.2463 85.0533 61.5729L86.5266 63.6063C86.6733 63.8063 86.6733 64.1063 86.5266 64.3596L83.9999 68.7729C83.7733 69.1663 83.3066 69.2529 83.0599 68.9463",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5532 62.0195C84.3932 62.0195 84.2199 62.1129 84.1132 62.2929L82.0932 65.8195C82.0399 65.9129 82.0132 66.0195 82.0132 66.1195C82.0132 66.2329 82.0465 66.3395 82.1132 66.4262L83.3399 67.9595C83.4199 68.0595 83.5332 68.1062 83.6465 68.1062C83.8065 68.1062 83.9799 68.0129 84.0865 67.8329L86.0665 64.3862C86.1199 64.2929 86.1465 64.1862 86.1465 64.0862C86.1465 63.9795 86.1132 63.8795 86.0532 63.7929L84.8665 62.1862C84.7865 62.0795 84.6732 62.0262 84.5532 62.0262",
    fill: "#95EFC6"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4732 67.8795H82.4532C82.3732 67.8662 82.3132 67.7729 82.3132 67.6395C82.3132 67.6062 82.3132 67.5729 82.3266 67.5395C82.3599 67.3729 82.4732 67.2595 82.5666 67.2595H82.5866C82.6666 67.2729 82.7266 67.3662 82.7266 67.4995C82.7266 67.5329 82.7266 67.5662 82.7132 67.5995C82.6799 67.7662 82.5666 67.8795 82.4732 67.8795ZM82.5666 67.1929C82.4199 67.1929 82.2999 67.3395 82.2599 67.5262C82.2532 67.5662 82.2466 67.5995 82.2466 67.6395C82.2466 67.7929 82.3132 67.9262 82.4399 67.9462H82.4732C82.6199 67.9462 82.7399 67.7995 82.7799 67.6195C82.7866 67.5795 82.7932 67.5462 82.7932 67.5062C82.7932 67.3529 82.7266 67.2195 82.5999 67.1995H82.5666",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9203 62.6396L83.5137 63.3397L84.827 66.5396L85.4603 65.4263L83.9203 62.6396Z",
    fill: "#BBF9DC"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1668 63.9598L82.9668 64.3065L84.4535 67.1931L84.6001 66.9331L83.2668 63.7798",
    fill: "#BBF9DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31451_20360",
    x1: 70.2802,
    y1: 66.4265,
    x2: 56.6802,
    y2: 66.4265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31451_20360",
    x1: 65.441,
    y1: 61.9618,
    x2: 58.195,
    y2: 60.8737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationFarAway);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-far-away.41b1c820f41405ad03d8bd7d0e1221e3.svg";